
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M12 2l.117.007a1 1 0 01.876.876L13 3v4l.005.15a2 2 0 001.838 1.844L15 9h4l.117.007a1 1 0 01.876.876L20 10v9a3 3 0 01-2.824 2.995L17 22H7a3 3 0 01-2.995-2.824L4 19V5a3 3 0 012.824-2.995L7 2z"}}),_c('path',{attrs:{"d":"M19 7h-4l-.001-4.001z"}})])])
          )
        }
      }
    